"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkClientsideResourceCost = exports.destroyClientsideBullet = exports.updateClientBullets = exports.handleCauthStaticShot = exports.handleCauthMeleeShot = exports.handleCauthProjectileShot = exports.handleMultiProjectile = exports.activeBullets = void 0;
const updateGroups_1 = require("./updateGroups");
const create_1 = require("./create");
const utils_1 = require("../server/utils");
var DEG_TO_RAD = Phaser.Math.DEG_TO_RAD;
const collisions_1 = require("../shared/collisions");
const game_1 = require("./game");
const input_1 = require("./input");
const phaserUtils_1 = require("./phaserUtils");
const equippedSpells_1 = require("./equippedSpells");
const constants_1 = __importDefault(require("../shared/constants"));
exports.activeBullets = [];
let idCounter = 1;
function handleMultiProjectile(pos, spellData, bulletInfo, dir) {
    let bulletX = pos.x;
    let bulletY = pos.y;
    let flip = 1;
    let perBulletDelay = 0;
    for (let n = 0; n < spellData.bullets; n++) {
        let playerShootDir = 0;
        let bulletDelay = 0;
        let randomSpreadFactor = 0;
        if (spellData.randomBulletDelay) {
            bulletDelay = (0, utils_1.getRandomNumberBetween)(spellData.randomBulletDelay.min, spellData.randomBulletDelay.max);
        }
        else if (spellData.bulletDelay) {
            bulletDelay = spellData.bulletDelay;
        }
        if (spellData.perBulletDelay) {
            perBulletDelay += spellData.perBulletDelay;
            bulletDelay = perBulletDelay;
        }
        if (spellData.randomSpreadFactor) {
            randomSpreadFactor = (0, utils_1.getRandomNumberBetween)(-spellData.randomSpreadFactor, spellData.randomSpreadFactor);
        }
        let dirModifier = (spellData.spread + randomSpreadFactor) * flip * Math.ceil(n / 2);
        dirModifier *= DEG_TO_RAD;
        let shootDir = dir;
        playerShootDir = shootDir + dirModifier;
        let bulletData = {
            x: bulletX + (5 * Math.cos(playerShootDir)),
            y: bulletY + (5 * Math.sin(playerShootDir)),
            direction: playerShootDir,
            radius: spellData.radius,
            trackedEntity: undefined,
        };
        bulletData.x = bulletX + (5 * Math.cos(playerShootDir));
        bulletData.y = bulletY + (5 * Math.sin(playerShootDir));
        bulletData.direction = playerShootDir;
        if (bulletDelay) {
            setTimeout(() => {
                createClientsideBullet(spellData, bulletData);
            }, bulletDelay);
        }
        else {
            createClientsideBullet(spellData, bulletData);
        }
        flip = (flip == 1) ? -1 : 1;
    }
}
exports.handleMultiProjectile = handleMultiProjectile;
function handleCauthProjectileShot(dir, spellData, clickData = undefined) {
    const bulletInfo = {
        x: create_1.player.x + (5 * Math.cos(dir)),
        y: create_1.player.y + (5 * Math.sin(dir)),
        direction: dir,
        radius: spellData.radius,
        trackedEntity: undefined,
    };
    if (spellData.trackEntity && clickData && clickData.objectRef) {
        bulletInfo.trackedEntity = clickData;
    }
    if (spellData.type === 'multi' || spellData.type2 === 'multi') {
        handleMultiProjectile(create_1.player, spellData, bulletInfo, dir);
    }
    else {
        createClientsideBullet(spellData, bulletInfo);
    }
}
exports.handleCauthProjectileShot = handleCauthProjectileShot;
function handleCauthMeleeShot(dir, spellData, clickData = undefined, extraMultiplier = 1) {
    const bulletInfo = {
        x: create_1.player.x + (8 * constants_1.default.MELEE_RADIUS_RATIO * Math.cos(dir)),
        y: create_1.player.y + (8 * constants_1.default.MELEE_RADIUS_RATIO * Math.sin(dir)),
        direction: dir,
        radius: spellData.radius,
        trackedEntity: undefined,
        extraMultiplier: extraMultiplier,
    };
    if (spellData.trackEntity && clickData && clickData.objectRef) {
        bulletInfo.trackedEntity = clickData;
    }
    createClientsideBullet(spellData, bulletInfo);
}
exports.handleCauthMeleeShot = handleCauthMeleeShot;
function handleCauthStaticShot(mousePos, dir, spellData, clickData) {
    const bulletInfo = {
        x: mousePos.x,
        y: mousePos.y,
        direction: dir,
        radius: spellData.radius,
        trackedEntity: undefined,
    };
    if (spellData.trackEntity && clickData && clickData.objectRef) {
        bulletInfo.trackedEntity = clickData;
    }
    if (spellData.type === 'multiStatic') {
        let bulletX = mousePos.x;
        let bulletY = mousePos.y;
        let perBulletDelay = 0;
        for (let n = 0; n < spellData.bullets; n++) {
            const multiStaticBulletInfo = {
                x: mousePos.x,
                y: mousePos.y,
                direction: dir,
                radius: spellData.radius,
                trackedEntity: undefined,
            };
            let bulletDelay = 0;
            if (spellData.randomBulletDelay) {
                bulletDelay = (0, utils_1.getRandomNumberBetween)(spellData.randomBulletDelay.min, spellData.randomBulletDelay.max);
            }
            else if (spellData.bulletDelay) {
                bulletDelay = spellData.bulletDelay;
            }
            if (spellData.perBulletDelay) {
                perBulletDelay += spellData.perBulletDelay;
                bulletDelay = perBulletDelay;
            }
            let xMin = Math.ceil(spellData.xDistanceRange.min);
            let xMax = Math.floor(spellData.xDistanceRange.max);
            let randomDistanceX = Math.floor(Math.random() * (xMax - xMin + 1)) + xMin;
            let yMin = Math.ceil(spellData.yDistanceRange.min);
            let yMax = Math.floor(spellData.yDistanceRange.max);
            let randomDistanceY = Math.floor(Math.random() * (yMax - yMin + 1)) + yMin;
            if (Math.random() > 0.5) {
                randomDistanceX *= -1;
            }
            if (Math.random() > 0.5) {
                randomDistanceY *= -1;
            }
            multiStaticBulletInfo.x = bulletX + randomDistanceX;
            multiStaticBulletInfo.y = bulletY + randomDistanceY;
            if (bulletDelay) {
                setTimeout(() => {
                    createClientsideBullet(spellData, multiStaticBulletInfo);
                }, bulletDelay);
            }
            else {
                createClientsideBullet(spellData, multiStaticBulletInfo);
            }
        }
    }
    else if (spellData.castAtPointer && spellData.type !== 'static') {
        // cast at pointer, but cast the original spell from pointer
        if (spellData.type === 'multi') {
            handleMultiProjectile(mousePos, spellData, bulletInfo, dir);
        }
    }
    else {
        let bulletDelay = 0;
        if (spellData.randomBulletDelay) {
            bulletDelay = (0, utils_1.getRandomNumberBetween)(spellData.randomBulletDelay.min, spellData.randomBulletDelay.max);
        }
        else if (spellData.bulletDelay) {
            bulletDelay = spellData.bulletDelay;
        }
        if (bulletDelay) {
            setTimeout(() => {
                createClientsideBullet(spellData, bulletInfo);
            }, bulletDelay);
        }
        else {
            createClientsideBullet(spellData, bulletInfo);
        }
    }
}
exports.handleCauthStaticShot = handleCauthStaticShot;
function createClientsideBullet(spellData, bulletInfo) {
    // console.log('[DEBUG] createCBullet: ', spellData, bulletInfo)
    if (spellData.type === 'multi' || spellData.type2 === 'multi' || spellData.type === 'projectile' || spellData.type === 'melee') {
        if (spellData.spawnOffset) {
            // offset in the direction of player
            bulletInfo.x += spellData.spawnOffset * Math.cos(bulletInfo.direction);
            bulletInfo.y += spellData.spawnOffset * Math.sin(bulletInfo.direction);
        }
        if (spellData.spawnOffsetX) {
            //X offset pegged to player when direction is 0
            bulletInfo.x += spellData.spawnOffsetX * Math.cos(bulletInfo.direction);
            bulletInfo.y += spellData.spawnOffsetX * Math.sin(bulletInfo.direction);
        }
        if (spellData.spawnOffsetY) {
            // Y offset pegged to player when direction is 0
            // subtracting as y is inverted in tiled/phaser space
            bulletInfo.x -= spellData.spawnOffsetY * Math.sin(bulletInfo.direction);
            bulletInfo.y += spellData.spawnOffsetY * Math.cos(bulletInfo.direction);
        }
    }
    if (bulletInfo.trackedEntity && bulletInfo.trackedEntity.objectRef && bulletInfo.trackedEntity.objectRef.radius && spellData.wrapEntity) {
        bulletInfo.radius = bulletInfo.trackedEntity.objectRef.radius;
        if (spellData.limitWrapSize) {
            if (Math.abs(bulletInfo.trackedEntity.objectRef.radius - spellData.radius) <= bulletInfo.trackedEntity.objectRef.radius / 2) {
                if (spellData.radius <= bulletInfo.trackedEntity.objectRef.radius) {
                    bulletInfo.radius = bulletInfo.trackedEntity.objectRef.radius - bulletInfo.trackedEntity.objectRef.radius * Math.abs((bulletInfo.trackedEntity.objectRef.radius - spellData.radius) / bulletInfo.trackedEntity.objectRef.radius);
                    // spell size is close to entity, but entity is really small2
                    let smallEntityRadius = 8;
                    if (bulletInfo.trackedEntity.objectRef.radius < smallEntityRadius) {
                        bulletInfo.radius = bulletInfo.trackedEntity.objectRef.radius;
                    }
                }
                else {
                    bulletInfo.radius = bulletInfo.trackedEntity.objectRef.radius + bulletInfo.trackedEntity.objectRef.radius * Math.abs((bulletInfo.trackedEntity.objectRef.radius - spellData.radius) / bulletInfo.trackedEntity.objectRef.radius);
                }
            }
            else {
                if (spellData.radius <= bulletInfo.trackedEntity.objectRef.radius) {
                    bulletInfo.radius = (bulletInfo.trackedEntity.objectRef.radius) - spellData.radius * Math.abs((bulletInfo.trackedEntity.objectRef.radius - spellData.radius) / bulletInfo.trackedEntity.objectRef.radius);
                    // spell is much smaller than entity, check if entity is too large?
                    let largeEntityRadius = 13;
                    if (bulletInfo.trackedEntity.objectRef.radius > largeEntityRadius) {
                        let radiusDiff = bulletInfo.trackedEntity.objectRef.radius - largeEntityRadius;
                        let radiusLimitScaling = Math.round(radiusDiff / 4);
                        bulletInfo.radius = (bulletInfo.trackedEntity.objectRef.radius * Math.abs((bulletInfo.trackedEntity.objectRef.radius - spellData.radius) / (bulletInfo.trackedEntity.objectRef.radius))) - spellData.radius * Math.abs((bulletInfo.trackedEntity.objectRef.radius - spellData.radius) / bulletInfo.trackedEntity.objectRef.radius) * radiusLimitScaling;
                    }
                }
                else {
                    bulletInfo.radius = (bulletInfo.trackedEntity.objectRef.radius) + spellData.radius * Math.abs((bulletInfo.trackedEntity.objectRef.radius - spellData.radius) / bulletInfo.trackedEntity.objectRef.radius);
                }
            }
        }
    }
    let bullet = (0, updateGroups_1.createBulletSprite)(spellData, bulletInfo, true);
    if (!bullet) {
        console.log('failed to create bullet sprite');
        return;
    }
    bullet.spellData = spellData;
    bullet.damage = spellData.damage;
    bullet.speed = spellData.speed;
    bullet.spellID = spellData.spellID;
    bullet.maxDistance = spellData.maxDistance;
    bullet.creationCoords = JSON.parse(JSON.stringify({ x: bulletInfo.x, y: bulletInfo.y }));
    bullet.bulletId = idCounter;
    idCounter++;
    if (idCounter > 100000) {
        idCounter = 1;
    }
    bullet.hitCache = [];
    if (bulletInfo.trackedEntity) {
        bullet.trackedEntity = bulletInfo.trackedEntity;
    }
    else {
        bullet.trackedEntity = undefined;
    }
    if (bulletInfo.extraMultiplier && bulletInfo.extraMultiplier !== 1) {
        bullet.damage *= bulletInfo.extraMultiplier;
    }
    // phaserObject.clientsideBullets.add(bullet)
    bullet.originalAngle = bullet.rotation;
    exports.activeBullets.push(bullet);
    if (spellData.type === 'static' || spellData.type === 'multiStatic') {
        (0, updateGroups_1.createBulletCollision)(bullet, bulletInfo, 'static', spellData);
    }
    else if (spellData.type === 'self') {
        bulletInfo.x = create_1.player.x;
        bulletInfo.y = create_1.player.y;
        (0, updateGroups_1.createBulletCollision)(bullet, bulletInfo, 'self', spellData);
    }
    else if (spellData.type === 'melee' && !spellData.type2) {
        (0, updateGroups_1.createBulletCollision)(bullet, bulletInfo, 'melee', spellData);
    }
    else {
        (0, updateGroups_1.createBulletCollision)(bullet, bulletInfo, 'projectile', spellData);
    }
    bullet.collisionBody.clientsideBullet = true;
    bullet.collisionBody.deactivated = false;
    if (spellData.duration) {
        bullet.duration = spellData.duration;
    }
    else if (spellData.type === 'static' || spellData.type === 'multiStatic' || spellData.type === 'self') {
        if (spellData.chargeCooldown) {
            bullet.duration = spellData.chargeCooldown;
        }
        else {
            bullet.duration = 1;
        }
    }
    else if (spellData.type === 'melee' && !spellData.type2) {
        bullet.duration = 0.2;
    }
    else {
        bullet.duration = 10;
    }
}
function updateClientBullets(dt) {
    exports.activeBullets.forEach(bullet => {
        // bullet.x += (bullet.spellData.speed * dt) * Math.cos(bullet.rotation)
        // bullet.y += (bullet.spellData.speed * dt) * Math.sin(bullet.rotation)
        let normalBulletMovement;
        if (bullet.type === 'self' && bullet.collisionBody.charged !== true) {
            bullet.x = create_1.player.x;
            bullet.y = create_1.player.y;
        }
        else if (bullet.trackedEntity) {
            if (bullet.trackedEntity.objectRef && bullet.trackedEntity.objectRef.x && bullet.trackedEntity.objectRef.y) {
                if (bullet.type === 'static') {
                    bullet.x = bullet.trackedEntity.objectRef.x;
                    bullet.y = bullet.trackedEntity.objectRef.y;
                }
                else if (bullet.type === 'projectile' || bullet.type === 'multi') {
                    bullet.x += (bullet.speed * dt) * Math.cos(bullet.originalAngle);
                    bullet.y += (bullet.speed * dt) * Math.sin(bullet.originalAngle);
                    let newAngle = Phaser.Math.Angle.Between(bullet.x, bullet.y, bullet.trackedEntity.objectRef.x, bullet.trackedEntity.objectRef.y);
                    let diff = Phaser.Math.Angle.Wrap(newAngle - bullet.rotation);
                    // console.log('[DEBUG] trackedEntry test. current radian: ', bullet.originalAngle, ', new radian: ', newAngle, ', diff: ', diff)
                    if (Math.abs(diff) > 0) {
                        let percentage = Math.min(bullet.speed * dt / (0, phaserUtils_1.distance)({ x: bullet.x, y: bullet.y }, { x: bullet.trackedEntity.objectRef.x, y: bullet.trackedEntity.objectRef.y }), 1);
                        let rotationAmount = percentage * diff;
                        if (diff > 0) {
                            bullet.rotation += rotationAmount;
                        }
                        else {
                            bullet.rotation -= rotationAmount;
                        }
                        bullet.rotation = Phaser.Math.Angle.Wrap(bullet.rotation);
                        bullet.originalAngle = bullet.rotation;
                        // console.log('[DEBUG] trackedEntry test. percentage: ', percentage,', rotation: ', rotationAmount,' changed radian: ', bullet.originalAngle)
                    }
                }
                else {
                    normalBulletMovement = true;
                }
            }
            else {
                normalBulletMovement = true;
            }
        }
        else {
            normalBulletMovement = true;
        }
        if (normalBulletMovement) {
            bullet.x += (bullet.speed * dt) * Math.cos(bullet.originalAngle);
            bullet.y += (bullet.speed * dt) * Math.sin(bullet.originalAngle);
        }
        bullet.collisionBody.x = bullet.x;
        bullet.collisionBody.y = bullet.y;
        bullet.duration -= dt;
        if ((bullet.type === 'static' || bullet.type === 'multiStatic' || bullet.type === 'self') && bullet.collisionBody.charged === true) {
            destroyClientsideBullet(bullet);
            return;
        }
        if (bullet.duration <= 0) {
            destroyClientsideBullet(bullet);
        }
        else if (bullet.maxDistance && (0, phaserUtils_1.distance)(bullet.creationCoords, bullet) >= bullet.maxDistance) {
            destroyClientsideBullet(bullet);
        }
        else {
            if ((typeof bullet.collisionBody === 'undefined' || bullet.active === false || bullet.visible === false) && bullet.type !== 'melee') {
                console.log('bullet is deactivated. try cleanup');
                destroyClientsideBullet(bullet);
                return;
            }
            const potentials = (0, collisions_1.getPotentialMatches)(game_1.collisions, bullet.collisionBody);
            for (let i = 0; i < potentials.length; i++) {
                const object = potentials[i];
                if (object.deactivated || typeof bullet.collisionBody === 'undefined') {
                    continue;
                }
                if (!bullet.hitCache.includes(object) && (0, collisions_1.checkCollision)(game_1.collisions, bullet.collisionBody, object)) {
                    if (!object.objectType) {
                        if (!(bullet.type === 'static' || bullet.type === 'multiStatic' || bullet.type === 'self' || bullet.type === 'melee')) {
                            destroyClientsideBullet(bullet);
                        }
                    }
                    else if (object.objectType === 'enemy') {
                        if ((bullet.damage < 0 && !object.isPet) || (bullet.damage > 0 && object.isPet)) {
                            continue;
                        }
                        (0, input_1.handleGiveDamage)(bullet.damage, bullet.spellID, object.enemyServerId);
                        if (!(bullet.type === 'static' || bullet.type === 'multiStatic' || bullet.type === 'self' || bullet.type === 'melee' || bullet.spellData.hitsMultipleTargets)) {
                            destroyClientsideBullet(bullet);
                        }
                        else {
                            bullet.hitCache.push(object);
                        }
                    }
                    else if (object.objectType === 'player' && (bullet.type === 'static' || bullet.type === 'multiStatic' || bullet.type === 'self') && bullet.spellData.damage < 0) {
                        (0, input_1.handleTakeDamage)(bullet.damage, bullet.spellID);
                        bullet.hitCache.push(object);
                    }
                    else if (object.objectType === 'otherPlayer') {
                        if ((bullet.type === 'projectile' || bullet.type === 'multi' || bullet.spellData.hitsMultipleTargets) && !bullet.isFriendly && equippedSpells_1.serverSettings.fullObjTest.pvpEnabled) {
                            destroyClientsideBullet(bullet);
                        }
                        // not handled yet, but should be. how to set other player healing/dmg?
                    }
                }
            }
        }
    });
}
exports.updateClientBullets = updateClientBullets;
function destroyClientsideBullet(bullet, cleanup = false) {
    bullet.sound.stop(bullet.soundData.cast);
    if (create_1.phaserObject.game.hasFocus && bullet.soundData.impact && cleanup === false) {
        bullet.sound.play(bullet.soundData.impact);
    }
    if (bullet.collisionBody) {
        let collisionBodyRef = bullet.collisionBody;
        collisionBodyRef.deactivated = true;
        game_1.collisions.remove(collisionBodyRef);
    }
    bullet.collisionBody = undefined;
    create_1.phaserObject.clientsideBullets.killAndHide(bullet);
    let activeBulletIndex = exports.activeBullets.indexOf(bullet);
    if (activeBulletIndex !== -1) {
        exports.activeBullets.splice(activeBulletIndex, 1);
    }
    else {
        console.log('active bullet index not found. client bulletId: ', bullet.bulletId);
    }
    bullet.id = -2;
    if (!cleanup) {
        create_1.phaserObject.clientsideBullets.remove(bullet);
        if (!bullet.noSprite) {
            create_1.entityPoolManager.addObjectToPool('bullets', bullet.spriteName, bullet);
        }
        else {
            create_1.entityPoolManager.addObjectToPool('bullets', 'noSpriteBullets', bullet);
        }
    }
    else {
        create_1.phaserObject.clientsideBullets.remove(bullet, undefined, true);
    }
}
exports.destroyClientsideBullet = destroyClientsideBullet;
function checkClientsideResourceCost(player, playerResources, equippedSpell, cauthResourceTracking = true) {
    if (equippedSpell.resourceCost) {
        if (equippedSpell.resourceCost.resource === 'mana') {
            if (player.manaVal >= equippedSpell.resourceCost.cost) {
                // let changeVal = ((equippedSpell.resourceCost.cost/player.maxMana)*100)
                // if (cauthResourceTracking) {
                //     player.manaBar.value -= changeVal
                // }
                return true;
            }
            else {
                return false;
            }
        }
        else if (playerResources[equippedSpell.resourceCost.resource] && playerResources[equippedSpell.resourceCost.resource].value >= equippedSpell.resourceCost.cost) {
            if (cauthResourceTracking) {
                playerResources[equippedSpell.resourceCost.resource].value -= equippedSpell.resourceCost.cost;
            }
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return true;
    }
}
exports.checkClientsideResourceCost = checkClientsideResourceCost;
